module.exports = __webpack_public_path__ + "img/productionBase_9.bcd89721.png";